import React, { FC, useState, useEffect } from 'react';
import { loadingModalViewStore } from 'src/store/modal';
import LoadingBar from './loading';
import _ from 'lodash';
import './style.scss';

interface Props {}

/**
 * Loading 레이아웃
 * 페이지 로딩 시 호출
 */
const LoadingLayout: FC<Props> = () => {
  const viewActive = loadingModalViewStore((state: any) => state.result)?.active || '';
  return (
    <div className={['_loading_center_layout', viewActive].join(' ')}>
      <div className="_bg_box" />
      <div className="_content_box ">
        <div className="_icon">
          <LoadingBar />
        </div>
        <div className="_label">Loading</div>
      </div>
    </div>
  );
};

export default LoadingLayout;
